// Generated by scripts/audit-quiz-image-ratios.mjs, then hand-curated —
// NOT purely machine-generated. The script only ADDS entries for genuinely
// new images on re-run; it never overwrites an existing entry, so any
// judgment below is safe from a future re-run (see the script for how).
//
// Per-image crop anchor for the quiz's fixed 3:2 photo box (Option D — see
// Extra Files/Claude Design - Handoff Files/design_handoff_quiz_photo_panel_option_d/README.md).
// Every image defaults to "50% 50%" (centre). Only entries flagged with a
// TODO (ratio outside 1.35-1.7) lose enough of the frame on one axis
// that a human should pick a better anchor by eye — see the handoff's worked
// examples (s1-s8) for the reasoning. A plain "// ratio X.XX" comment means
// that entry was never flagged, or was flagged and judged to stay centred.
export const QUIZ_IMAGE_ANCHORS: Record<string, string> = {
  "priorities-1": "55% 50%", // ratio 1.78 — photographer sits right of centre; crop off the left reeds
  "priorities-2": "50% 50%", // ratio 1.78 — both cubs well inside the centre window
  "priorities-3": "50% 50%", // ratio 1.78 — couple centred; only vehicle nose and tail are lost
  "priorities-4": "50% 50%", // ratio 1.50
  "priorities-5": "42% 50%", // ratio 1.82 — three cubs walk the left third; hold left or the lead cub clips
  "priorities-6": "50% 50%", // ratio 1.50
  "priorities-7": "50% 50%", // ratio 1.51
  "priorities-8": "50% 50%", // ratio 1.50
  "priorities-9": "50% 50%", // ratio 1.51
  "priorities-10": "50% 50%", // ratio 1.50
  "priorities-11": "50% 50%", // ratio 1.50
  "priorities-12": "50% 50%", // ratio 1.50
  "priorities-13": "50% 50%", // ratio 1.46
  "priorities-14": "50% 50%", // ratio 1.50
  "priorities-15": "50% 50%", // ratio 1.57
  "priorities-16": "50% 50%", // ratio 1.50
  "priorities-17": "50% 50%", // ratio 1.50
  "priorities-18": "50% 50%", // ratio 1.41
  "priorities-19": "50% 50%", // ratio 1.53
  "priorities-20": "55% 50%", // ratio 1.81 — herd runs to the right edge; hold right to keep the last elephant
  "priorities-21": "50% 50%", // ratio 1.33 — Return Africa panel is dead centre
  "priorities-22": "50% 58%", // ratio 1.33 — termite mound sits low; keep its base, lose sky
  "priorities-23": "50% 60%", // ratio 1.33 — vehicle occupies the lower frame; keep it, lose canopy
  "priorities-24": "50% 50%", // ratio 1.41
  "priorities-25": "50% 50%", // ratio 1.50
  "priorities-26": "50% 50%", // ratio 1.50
  "priorities-27": "50% 50%", // ratio 1.50
  "priorities-28": "50% 50%", // ratio 1.50
  "priorities-29": "50% 50%", // ratio 1.50
  "priorities-30": "50% 50%", // ratio 1.50
  "priorities-31": "50% 50%", // ratio 1.82 — both silhouettes inside the centre window
  "priorities-32": "50% 50%", // ratio 1.86 — leopard and tail both survive centre; edges are water
  "priorities-33": "50% 42%", // ratio 1.30 — wild dog's ears are near the top; hold high
  "priorities-34": "50% 50%", // ratio 1.47
  "priorities-35": "50% 62%", // ratio 1.22 — three staff standing; centre crop cuts their feet
  "priorities-36": "50% 50%", // ratio 1.50
  "priorities-37": "50% 50%", // ratio 1.50
  "priorities-38": "50% 72%", // ratio 1.27 — backlit leopard sits very low; sky is expendable
  "priorities-39": "40% 50%", // ratio 1.88 — hyena faces are left of centre; crop off the open water
  "priorities-40": "50% 50%", // ratio 1.86 — open sunset, nothing to protect
  "constraints-1": "50% 50%", // ratio 1.78 — guide and far vehicle both inside centre
  "constraints-2": "50% 50%", // ratio 1.78 — bush breakfast table is centred
  "constraints-3": "50% 50%", // ratio 1.78 — guest centred against the vehicle
  "constraints-4": "50% 50%", // ratio 1.50
  "constraints-5": "50% 50%", // ratio 1.50
  "constraints-6": "50% 50%", // ratio 1.63
  "constraints-7": "50% 55%", // ratio 1.31 — tusker fills the lower frame; protect the tusks
  "constraints-8": "50% 50%", // ratio 1.50
  "constraints-9": "50% 50%", // ratio 1.50
  "constraints-10": "50% 50%", // ratio 1.90 — wide floodplain, no subject to lose
  "constraints-11": "50% 50%", // ratio 1.36
  "constraints-12": "50% 50%", // ratio 1.50
  "constraints-13": "50% 50%", // ratio 1.30 — elephant and guide both mid-frame
  "constraints-14": "50% 50%", // ratio 1.34 — giraffe on the horizon, mid-frame
  "constraints-15": "50% 50%", // ratio 1.50
  "constraints-16": "50% 50%", // ratio 1.50
  "constraints-17": "50% 50%", // ratio 1.50
  "constraints-18": "50% 50%", // ratio 1.51
  "constraints-19": "50% 50%", // ratio 1.39
  "constraints-20": "50% 50%", // ratio 1.33 — leopard lies across the middle of the frame
  "constraints-21": "50% 58%", // ratio 1.33 — vehicle sits low in frame; keep the wheels
  "constraints-22": "50% 50%", // ratio 1.33 — river scene, horizon high, safe centred
  "constraints-23": "50% 50%", // ratio 1.51
  "constraints-24": "50% 50%", // ratio 1.45
  "constraints-25": "50% 50%", // ratio 1.50
  "constraints-26": "50% 50%", // ratio 1.33 — full-height trees, canopy lost at any anchor; centre is the fairest of several bad options. Real fix is swapping the photo.
  "constraints-27": "50% 50%", // ratio 1.50
  "constraints-28": "50% 50%", // ratio 1.50
  "constraints-29": "50% 50%", // ratio 1.50
  "constraints-30": "50% 50%", // ratio 1.51
  "constraints-31": "50% 50%", // ratio 1.50
  "constraints-32": "50% 50%", // ratio 1.50
  "constraints-33": "50% 62%", // ratio 1.23 — bonnet and guide occupy the bottom; hold low
  "constraints-34": "50% 50%", // ratio 1.47
  "constraints-35": "50% 50%", // ratio 1.50
  "constraints-36": "50% 50%", // ratio 1.50
  "constraints-37": "50% 50%", // ratio 1.50
  "constraints-38": "50% 50%", // ratio 1.79 — herd sits centre-right but inside the window
  "constraints-39": "50% 50%", // ratio 1.45
  "constraints-40": "50% 50%", // ratio 1.51
};
